<template>
  <v-dialog
    content-class="vcita-dialog"
  v-bind="$attrs"
  v-on="$listeners"
  transition="dialog-bottom-transition"
  :width="'unset'"
  >
    <template v-slot:activator="activatorData">
      <slot
        name="activator"
      v-bind="activatorData"
      >

      </slot>
    </template>
    <slot></slot>

  </v-dialog>
</template>

<script>
export default {
  name: 'VcitaDialog',

}
</script>

<style lang="scss" scoped>
</style>
